<template>
  <v-card class="main-container">
    <v-tabs v-model="tabs" fixed-tabs>
      <v-tab :key="1">Активные заявки</v-tab>
      <v-tab :key="2">Мои экспертные советы</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tabs" class="white elevation-1">
      <v-tab-item :key="1">

        <v-card-text>
          <div v-if="GETTERS_LOGIN">
            <v-list class="d-flex align-center justify-start">
              <v-list-item>
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="orange_bg"
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      style="cursor:help;"
                    >
                      необходимо оценить
                    </v-btn>
                  </template>
                  <span>Вы назначены экспертом по заявке. До начала Экспертного совета необходимо провести оценку заявки.</span>
                </v-tooltip>
              </v-list-item>

              <v-list-item>
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="green_bg"
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      style="cursor:help;"
                      >
                        оценка выставлена
                    </v-btn>
                  </template>
                  <span>Вы уже оценили заявку. До начала Экспертного совета есть возможность изменить выставленную оценку.</span>
                </v-tooltip>
              </v-list-item>
              <v-list-item>
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="red_bg"
                      @click=""
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      style="cursor:help;"
                    >
                      просрочено
                    </v-btn>
                  </template>
                    <span>Период оценки заявок данного Экспертного совета завершен</span>
                </v-tooltip>
              </v-list-item>
              <v-list-item>
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="gray_bg"
                      @click=""
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      style="cursor:help;"
                    >
                        черновик
                    </v-btn>
                  </template>
                  <span>Вы добавлены в качестве эксперта. Возможность оценить заявку появится после окончания "планирования" Экспертного совета</span>
                </v-tooltip>
              </v-list-item>
            </v-list>


            <v-list class="d-flex align-center justify-start">
              <v-list-item>
                <v-btn
                  @click="uploadToPdf()"
                  :disabled="selectedProposals.length === 0"
                  x-small>
                  <v-badge
                    x-small
                    color="#15336d"
                    :content="selectedProposals.length">
                    {{$t('ModeratorList.upload_to_pdf')}}
                  </v-badge>
                </v-btn>
                <v-btn
                  @click="uploadToExcel()"
                  :disabled="selectedProposals.length === 0"
                  x-small style="margin-left: 15px;">
                  <v-badge x-small color="#15336d"
                    :content="selectedProposals.length">
                    {{$t('ModeratorList.upload_to_excel')}}
                  </v-badge>
              </v-btn>

              </v-list-item>
            </v-list>

            <v-data-table
                v-model="selectedProposals"
                show-select
                :style="{color: $mainColor}"
                :headers="headers"
                :items="listProposals"
                item-key="id"
                dense
                :loading="preloaderYet"
                :loading-text="$t('User.loading_orders')"
                :items-per-page="20"
                :footer-props="{
                    itemsPerPageOptions: [10, 20, 50],
                    itemsPerPageText: 'кол-во на стр.:',
                }"
            >
              <template v-slot:header.station_name>
                <div class="d-flex align-center pb-1">
                  <!-- <span class="mr-2">Статус</span> -->
                  <v-select
                    v-model="selectedStation"
                    :items="stationOptions"
                    label="Станция"
                    dense
                    hide-details
                    outlined
                    class="ml-2"
                    style="min-width: 120px"
                    @change="filterByStation()"
                  ></v-select>
                </div>
              </template>
              <template v-slot:body="{ items, isSelected, select}">
                <tbody>
                  <tr v-for="item in items" :key="item.id" :class="row_classes(item)">
                    <td>
                      <v-checkbox
                        :input-value="isSelected(item)"
                        style="margin:0px;padding:0px"
                        color="#535353"
                        hide-details
                        @click=" custom_select(item)"
                      >
                      </v-checkbox>
                    </td>
                    <td @click="open_proposal_card(item.id)" style="cursor: pointer;">
                      <span>
                            {{ item.id }}
                      </span>
                    </td>
                    <td @click="open_proposal_card(item.id)" style="cursor: pointer;">
                      <span>
                            {{ item.name ? item.name: $t('untitled') }}
                      </span>
                    </td>
                    <td @click="open_proposal_card(item.id)" style="cursor: pointer;">
                      <span>
                      {{ item.station_name }}
                      </span>
                    </td>
                    <td @click="open_proposal_card(item.id)" style="cursor: pointer;">
                      <span>
                      {{ item.author }}
                      </span>
                    </td>
                    <td @click="open_proposal_card(item.id)" style="cursor: pointer;">
                      <span>
                        {{ item.organisation }}
                      </span>
                    </td>
                    <td @click="open_proposal_card(item.id)" style="cursor: pointer;">
                      <span>
                        {{g.toDate(item.date_income)}}
                      </span>
                    </td>
                    <td>
                      <span>
                        <v-rating
                          v-model="item.mark"
                          readonly
                          half-increments
                          density="compact"
                          small
                        ></v-rating>
                      </span>
                    </td>
                    <td>
                      <v-tooltip left>
                          <template v-slot:activator="{ on, attrs }">
                              <v-icon
                              small
                              v-bind="attrs"
                              v-on="on"
                              @click="redirectDocument(item.id)">
                              mdi-file
                              </v-icon>
                          </template>
                          <span>экспорт в .pdf</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>

          </div>
        </v-card-text>

      </v-tab-item>

      <v-tab-item  :key="2">
        <council-list
          view_type="expert"
        />

      </v-tab-item>
    </v-tabs-items>

  </v-card>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import councilList from '../components/Council/councilList.vue';

export default {
  name: 'ExpertGrid',

  components: {
    councilList,
  },

  data() {
    return {
      selectedProposals: [],
      headers: [
          { text: 'ID', align: 'start', sortable: true, value: 'id'},
          { text: this.$t('name'), sortable: false, value: 'name'},
          { text: 'Станция', align: 'start', sortable: false, value: 'station_name'},
          { text: 'Заявитель', align: 'start', sortable: true, value: 'author', width:'120px'},
          { text: this.$t('ModeratorTabLayouts.organization'), align: 'start', sortable: true, value: 'organisation'},
          { text: this.$t('date_created'), align: 'start', sortable: true, value: 'date_income', width:'130px'},
          { text: 'Моя оценка', align: 'start', sortable: true, value: 'mark', width:'150px'},
          { text: this.$t('actions'), value: 'actions', sortable: false}
      ],
      listProposals: [],
      allListProposals: [],
      preloaderYet: false,
      expert_id: null,
      make_load: false,
      last_change_datetime: null,
      last_change_id: null,
      tabs: null,

      selectedStation: null,
      stationOptions:  ['Все'],
      call_id: null,
    };
  },

  async beforeMount() {
    this.updateExpert();
  },

  methods:{
    ...mapActions([
      'GET_EXPER',
      'GET_EXPERT_PROPOSAL_LIST',
      'GET_URL_PRD',
      'UPLOAD_LIST_TO_EXCEL',
    ]),
    ...mapMutations([
      'SHOW_PROPOSAL_CARD',
      'UPDATE_OVERLAY',
    ]),

    open_proposal_card(id) {
      this.call_id = new Date()
      this.SHOW_PROPOSAL_CARD({
        'proposal_id' : id,
        'call_id': this.call_id
      })
    },

    filterByStation(){
      if(!this.selectedStation || this.selectedStation == 'Все'){
        this.listProposals = this.allListProposals
      }
      else{
        this.listProposals = []
        this.allListProposals.forEach((item) => {
          if(item.station_name == this.selectedStation){
            this.listProposals.push(item)
          }
        });
      }
    },

    uploadToPdf() {
      const proposals = [];
      this.selectedProposals.forEach((item) => {
        proposals.push(item.id);
      });

      this.UPDATE_OVERLAY(true)
      this.GET_URL_PRD(proposals)
        .then(() => {
          this.UPDATE_OVERLAY(false)
        })
        .catch(() => {
          this.UPDATE_OVERLAY(false)
        });
    },
    uploadToExcel() {
      this.UPDATE_OVERLAY(true)
      const proposals = [];
      this.selectedProposals.forEach((item) => {
        proposals.push(item.id);
      });

      this.UPLOAD_LIST_TO_EXCEL({proposal_ids: proposals, type_id: 4})
        .then((res) => {
          this.UPDATE_OVERLAY(false)
          window.open(res.url, '_blank');
        })
        .catch((e) => {
          this.UPDATE_OVERLAY(false)
        });
    },

    custom_select(item){
      var  found = false
      this.selectedProposals.forEach(element => {
        if(element.id == item.id)
          found = true
      })

      if(this.last_change_id == item.id){
        var now = new Date()
        var diff = now - this.last_change_datetime
        if(diff < 250)
          return
      }
      this.last_change_id = item.id
      this.last_change_datetime = new Date();

      if(found){
        var temp_array = []
        this.selectedProposals.forEach(element => {
          if(element.id != item.id){
            temp_array.push(element)
          }
        })
        this.selectedProposals = temp_array
      }
      else{
        this.selectedProposals.push(item)
      }
    },

    row_classes(item) {
      if(item.last_status_id == 2)
        return "gray_bg";
      else if(item.mark && item.mark > 0)
          return "green_bg";
      else if (item.last_status_id == 4)
        return "red_bg";
      else
          return "orange_bg";
    },

    loadProposals() {
      this.preloaderYet = true;

      this.GET_EXPERT_PROPOSAL_LIST({
        // status_id: 104,
        expert_id: this.expert_id
      })
        .then((res) => {
          this.preloaderYet = false;
          this.allListProposals = res.data;
          this.listProposals = res.data;

          this.allListProposals.forEach((item) => {
            if(this.stationOptions.length == 0 || !this.stationOptions.includes(item.station_name)){
              this.stationOptions.push(item.station_name)
            }
          });
        })
        .catch(() => this.preloaderYet = false);
    },

    redirectDocument(request) {
      this.UPDATE_OVERLAY(true)
      this.GET_URL_PRD(request)
        .then(() => this.UPDATE_OVERLAY(false))
        .catch(() => this.UPDATE_OVERLAY(false));
    },

    updateExpert(){
      this.expert_id = parseInt(this.GETTERS_LOGIN);
      if(this.expert_id > 0){
        this.make_load = true;
      }
      else{
        setTimeout(() => {
          this.updateExpert();
        }, 1000);
      }
    },

  },

  computed: mapGetters([
    'GETTERS_LOGIN',
    'GETTERS_NEED_RELOAD_CLOSE_PROPOSAL',
  ]),

  watch: {
    make_load(val) {
      if (val) {
        this.loadProposals()
      }
    },

    GETTERS_NEED_RELOAD_CLOSE_PROPOSAL(val){
      if(val && val == this.call_id){
        this.loadProposals();
      }
    },
  }

};
</script>
<style lang="scss">
.gray_bg {
  background-color: #b4b4b48f !important;
}
.gray_bg:hover{
  background-color: #b4b4b4ab !important;
}

.red_bg {
  background-color: #ff000c54 !important;
}
.red_bg:hover {
  background-color: #ff000c73 !important;
}
.green_bg {
  background-color: #00ff0038 !important;
}
.green_bg:hover {
  background-color: #00ff0057 !important;
}
.orange_bg {
  background-color: #f2c85d96 !important;
}
.orange_bg:hover {
  background-color: #f2c85dab !important;
}

</style>
